/* eslint-disable react-hooks/exhaustive-deps */
import { AttachFile, ExpandMore, Save } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Accordion, AccordionDetails, AccordionSummary, Button, Card, CardContent, CardHeader, Container, CssBaseline, Grid, Typography } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import MyBreadcrumbs from '../../../../components/MyBreadcrumbs'
import { AuthStore } from '../../../../store/UserStore'
import { base_url } from '../../../../utils/GlobalVariables'
import { CustomDescrypt } from '../../../../utils/MyEncryption'

const FormProces = () => {
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [loading, setLoading] = useState(false);
    const logOut = AuthStore((state) => state.logOut);
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state || null;
    const [formData, setFormData] = useState({
        _method: "PUT",
        sp2d: "",
        no_spm: ""
    });
    const [src, setSrc] = useState("");

    useEffect(() => {
        setFormData({
            ...formData,
            no_spm: locationState.no_spm
        })
    }, [location])

    useEffect(() => {
        formData.sp2d === "" ?
            setSrc("")
            :
            setSrc(URL.createObjectURL(formData.sp2d))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.file_spm])

    const loadData = event => {
        const file = event.target.files[0];
        console.log(file);
        if (file === undefined || file === "") {
            console.log(formData);
        }
        else {
            setFormData({
                ...formData,
                sp2d: file
            })
        }
        console.log(formData);
    }

    function checkForm(obj) {
        for (var key in obj) {
            if (obj[key] === "")
                return false;
        }
        return true;
    }

    const updateData = () => {
        const isValid = checkForm(formData);
        if (!isValid) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Load File SP2D'
            })
            return;
        }

        console.log(formData);
        setLoading(true);
        axios.post(
            base_url + '/bnd/pencairan/upload-sp2d',
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })

                setFormData({
                    ...formData,
                    sp2d: "",
                    no_spm: ""
                });
                navigate(-1)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setLoading(false)
            })
    }

    return (
        <>
            <CssBaseline />
            <MyBreadcrumbs breadcrumbItem={{ '/bnd': 'Home', 'proses_sp2d': 'Proses SP2D', '': 'Upload SP2D' }} title="Proses SP2D" />
            <Container sx={{ my: 3 }} maxWidth="xxl">
                <Grid container spacing={2} direction="row"
                    justifyContent="center"
                >
                    <Grid item xs={12} md={12}>
                        <Card>
                            <CardHeader
                                title="Upload SP2D"
                            />
                            <CardContent>
                                <Grid container spacing={2} py={2} justifyContent="center">
                                    <Grid item xs={"auto"}>
                                        <Button
                                            variant="outlined"
                                            component="label"
                                            startIcon={<AttachFile />}
                                            color={
                                                formData.file === "" ? "error" : "primary"
                                            }
                                        >
                                            Upload SP2D
                                            <input
                                                hidden
                                                accept="application/pdf"
                                                multiple type="file"
                                                onChange={loadData}
                                            />
                                        </Button>
                                    </Grid>
                                </Grid>
                                {src === "" ?
                                    "" :
                                    <Grid container spacing={2} py={2} justifyContent="center">
                                        <Grid item xs={10} sx={{ textAlign: "center" }}>
                                            <Accordion>
                                                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                                    <Typography>File SP2D</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <iframe width='100%' height={700} title="Pdf" src={src} />
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    </Grid>
                                }
                                <Grid container spacing={2} py={2} justifyContent="flex-end">
                                    <Grid item >
                                        <LoadingButton
                                            onClick={updateData}
                                            loading={loading}
                                            variant="contained"
                                            margin="normal"
                                            loadingPosition="start"
                                            startIcon={<Save />}
                                        >
                                            Update
                                        </LoadingButton>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

export default FormProces